import * as React from 'react';

import { DimeDropdownMenuGroup, DimeDropdownMenuLabel } from '../DimeDropdownMenu.js';

export function DimeActionToolbarMenuGroup({
  label,
  children,
}: Readonly<{ label: string; children: React.ReactNode }>) {
  const labelId = React.useId();
  return (
    <DimeDropdownMenuGroup aria-labelledby={labelId}>
      <DimeDropdownMenuLabel id={labelId}>{label}</DimeDropdownMenuLabel>
      {children}
    </DimeDropdownMenuGroup>
  );
}
